import { GENERAL_USERS } from 'solaris-lens-common-lib/src/constants/services';
import { getExternalLinkAccessPoolName } from 'solaris-lens-common-lib-web/src/utils/getExternalLinkAccessPoolName';

type MeProfileApp = {
  poolName?: string;
  groups?: string[];
  enabled?: boolean;
  confirmationStatus?: string;
};

type MeProfileData = {
  profile?: Record<string, unknown>;
  groups?: string[];
  fleetIds?: string[];
  username?: string;
  email?: string;
  apps?: MeProfileApp[];
  [key: string]: unknown;
};

const readUsername = (source: MeProfileData = {}) => {
  const value =
    source.username ||
    source.email ||
    (source as { preferredUsername?: string }).preferredUsername ||
    '';

  return String(value).trim();
};

const resolveAppGroups = (meData: MeProfileData, poolName = '') => {
  const apps = Array.isArray(meData.apps) ? meData.apps : [];
  const accessPoolName = getExternalLinkAccessPoolName(poolName);

  const currentApp =
    apps.find(
      app => getExternalLinkAccessPoolName(app?.poolName) === accessPoolName
    ) ||
    apps[0] ||
    {};

  const appGroups = Array.isArray(currentApp.groups) ? currentApp.groups : [];
  if (appGroups.length) {
    return appGroups;
  }

  const profile = (meData.profile ?? {}) as MeProfileData;
  const legacyGroups = profile.groups ?? meData.groups ?? [];
  if (Array.isArray(legacyGroups) && legacyGroups.length) {
    return legacyGroups;
  }

  return [GENERAL_USERS];
};

/**
 * Maps GET /user-profiles/me into Pulse userProfile shape.
 * Groups live under apps[poolName].groups (multi-app) — pass Power pool for Pulse.
 */
export const mapMeProfileToUserProfile = (
  meData: MeProfileData = {},
  poolName = ''
) => {
  const profile = (meData.profile ?? {}) as MeProfileData;
  const username = String(meData.username ?? '').trim() || readUsername(meData);
  const groups = resolveAppGroups(meData, poolName);

  return {
    ...meData,
    ...profile,
    username,
    email: String(profile.email ?? meData.email ?? ''),
    name: String(profile.name ?? meData.name ?? ''),
    company: String(profile.company ?? meData.company ?? ''),
    companyId: profile.companyId ?? meData.companyId ?? '',
    groups,
    fleetIds: meData.fleetIds ?? profile.fleetIds ?? [],
    apps: meData.apps ?? profile.apps ?? [],
    attributes: {
      ...profile,
      groups
    },
    customAtributes: {
      ...profile,
      groups
    }
  };
};
